import { useMutation } from '@apollo/react-hooks';
import ADD_CONTACT_DATA_MUTATION from '../graphql/AddContactData.graphql';

const useContactData = () => {
  const [saveContactDataMutation] = useMutation(ADD_CONTACT_DATA_MUTATION);

  const saveContactData = (variables: {
    name: string;
    phoneNumber: string;
    originUrl?: string;
    source?: string;
    email?: string;
  }): Promise<any> => {
    return new Promise((resolve, reject) => {
      saveContactDataMutation({ variables })
        .then(res => {
          if (res.data.addContactData.success) {
            resolve({ success: res.data?.addContactData.success });
          }
        })
        .catch(err => {
          reject(err);
        });
    });
  };

  return { saveContactData };
};

export default useContactData;
